<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.comptable',2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card-title">
                    <router-link :to="{ name: 'add-accountant' }" v-if="can">
                        {{ $t('message.add') }}

                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div>

                <div class="row">
                    <b-container>
                        <b-row>
                            <b-col col sm="12">
                                <vue-good-table
                                        id="operation"
                                        :columns="comptableColumns"
                                        :rows="comptableRows"
                                        :search-options="{
                                        enabled:true,
                                        }"
                                        :pagination-options="paginationOptions"
                                        @on-row-click="onComptableClick"
                                />
                            </b-col>
                        </b-row>
                    </b-container>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from 'lodash';

    export default {
        name: "Accountants",
        computed: {
            ...mapGetters([
                "file",
                'hasAdminRole',
                'hasMedecinControleRole',
                'hasAssistante',
                'hasPatientRole',
                'hasPraticienRole',
                'hasSouscripteurRole',
                'hasGestionnaireRole',"userInstitutions",
            ]),

            can: function () {
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.hasAssistante;
            },

            comptableColumns: function () {
                return [
                    {
                        label: this.$i18n.tc('message.institution'),
                        field: 'institution',
                    },
                    {
                        label: this.$i18n.tc('message.comptable'),
                        field: 'comptable',
                    }
                ];
            },

            comptableRows:function(){
                let cArray = [];

                _.forEach(this.userInstitutions,function (institution) {
                    _.forEach(institution.comptables,function (comptable) {
                        let user = comptable.user;
                        if(!_.isNull(user)){
                            let prenom = (user.prenom == null) ? '' : user.prenom;
                            let nomComplet= (user.nom).toUpperCase() + " " +prenom.charAt(0).toUpperCase() + prenom.substring(1);
                            cArray.push({institution:institution.name,comptable:nomComplet,slug:comptable.slug});
                        }
                        

                        
                    })
                })
                return cArray;
            }
        },
        data(){
            return {
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },
            }
        },
        methods:{
            getUserInstitutions() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getUserInstitutions', { args : args });
            },

            onComptableClick(params){
                this.$router.push({ name: 'accountant', params: { accountant: params.row.slug } });

            }
        },
        mounted() {
            this.getUserInstitutions();
        }
    }
</script>

<style scoped>

</style>